import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {FormControlLabel, Checkbox} from '@material-ui/core';
import {
  saveAgreementAcknowledgment,
  clearAgreementAcknowledgment,
  changeAgreementAccepted,
} from 'Enrollment/ducks/enrollmentFileProcessing';
const BrokerSpreadsheetAcknowledgementStatement = () => {
    
  const dispatch = useDispatch();
  const {agreementAccepted} = useSelector((state: ReducerState) => state.enrollmentFileProcessing);
  const handleAgreementAcceptanceChange = (checked: boolean) => {
    dispatch(changeAgreementAccepted(checked));
    if (checked) {
      dispatch(saveAgreementAcknowledgment());
    } else {
      dispatch(clearAgreementAcknowledgment());
    }
  };
  return (
    <>
      <div className="acknowledgement-statment">
        <h4 className="acknowledgement-statment__title">Acknowledgement Agreement</h4>
        <p className="acknowledgement-statment__content">
          By submitting and uploading this enrollment data on behalf of the applicant(s), the undersigned certifies that
          to the best of his/her knowledge and belief, the information contained herein is true, complete and accurately
          recorded, and that each applicant: (a) is aware that the information contained herein forms the basis for
          his/her request for insurance; (b) has selected, in accordance with applicable law, the elections made and
          contribution amounts; (c) has authorized his/her employer to deduct from payroll necessary premium for the
          coverage(s) requested, if applicable; (d) has been provided with all required and approved applications,
          outlines of coverage, disclosures and/or disclosure forms; (e) has been made aware that the effective date of
          the elected coverages will be the effective dates indicated in the applicable certificates; and (f) has been
          advised that if any coverages the applicant is eligible for are not selected, satisfactory evidence of
          insurability may be required should he/she decide to apply at a later date.
        </p>
        <p className="acknowledgement-statment__content">
          The undersigned agrees to maintain reproducible records of and comply with all audit requests from AB related
          to any transactions conducted, including enrollment elections and changes, payroll and premium data, and any
          correspondence regarding enrollment elections or changes, for a period of at least 10 years from the date of
          termination of any non-Life policy and 20 years from the date of termination of any Life policy, or such other
          time as may be prescribed by AB.
        </p>
        <p className="acknowledgement-statment__content">
          The undersigned agrees that in the event any misrepresentation occurs, incorrect data is transmitted and
          processed as a result of information provided, or any violation of any applicable privacy law occurs as a
          result of the undersigned’s actions or omissions, the undersigned is fully liable and responsible for taking
          all corrective action required by AB and for indemnifying and holding AB harmless for any and all claims or
          liabilities resulting therefrom. Until all corrections have been made (or until AB is satisfied that proper
          corrective processes are in place), AB reserves the right to take necessary actions to ensure the errors are
          corrected (including, but not limited to, withholding of commissions and termination of the undersigned’s
          Agent Contract(s)).
        </p>
      </div>
      <div className="acknowledgement-statment-checkbox">
        {' '}
        <FormControlLabel
          control={
            <Checkbox
              checked={agreementAccepted}
              onChange={e => handleAgreementAcceptanceChange(e.target.checked)}
              name="checkedB"
              color="primary"
            />
          }
          label="I agree and accept the terms and conditions"
        />
      </div>
    </>
  );
};
export default BrokerSpreadsheetAcknowledgementStatement;
